import { render, staticRenderFns } from "./StandardBoxEdit.vue?vue&type=template&id=528a248a&scoped=true&"
import script from "./StandardBoxEdit.vue?vue&type=script&lang=js&"
export * from "./StandardBoxEdit.vue?vue&type=script&lang=js&"
import style0 from "./StandardBoxEdit.vue?vue&type=style&index=0&id=528a248a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528a248a",
  null
  
)

export default component.exports